import store from '@/store/store';
import { Nullable } from '@/utils/types';

export const getCurrentAccountId = (): Nullable<number> => {
  // should be here, as this function called in getDefaultGroupFilterObjectShape where store is init process
  if (!store) return null;

  return (store.state as any).activeAccount?.id || null;
}
